export const DOMAIN_CUSTOM_MODALS = "CUSTOM_MODALS";
